import React from 'react';
import CompanyLandingScreen from './screens/CompanyLandingScreen/CompanyLandingScreen';

function WelcomeLanding() {
  return <CompanyLandingScreen />;
}

export default WelcomeLanding;
